import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ReportsService } from './reports.service';
import { OrganizationType } from '../../state/models/organization';
import { FeatureFlagSearchNames } from '../../state/models/feature-flag';

export interface ILayoutConf {
  toolbarNav?: boolean;
  menu?: Menu[];
  menuFooter?: Menu[];
  updatedAt?: number;
  titlePage?: string;
}


@Injectable({
  providedIn: 'root'
})
export class MenuLayoutService {
  public layoutConf: ILayoutConf = {
    toolbarNav: true,
  };
  layoutConfSubject = new BehaviorSubject<ILayoutConf>(this.layoutConf);
  layoutConf$ = this.layoutConfSubject.asObservable();
  menu: Menu[] = [];
  menuFooter: Menu[] = [];

  constructor(
    private reportsService: ReportsService,
  ) {
    this.setMenu();
    this.setMenuFooter();
  }

  updateLayoutConfig() {
    this.setLayout({ updatedAt: new Date().getTime() });
  }

  setLayout(layoutConfSet: ILayoutConf) {
    this.layoutConf = { ...this.layoutConf, ...layoutConfSet };
    this.layoutConfSubject.next(this.layoutConf);
  }

  setMenuFooter() {
    this.menuFooter = [
      {
        type: 'divider'
      },
      {
        icon: 'person_outline',
        label: 'Perfil',
        shortLabel: 'Perfil',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/perfil',
        acl: ['HUMAN_RESOURCES', 'GROUP', 'SALESPERSON'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE',
        ]
      },
      {
        icon: 'manage_accounts',
        label: 'Acessos',
        shortLabel: 'Acessos',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/controle-de-acesso',
        acl: ['HEALTH_OPERATOR', 'BROKER'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
      {
        icon: 'logout',
        label: 'Sair',
        shortLabel: 'Sair',
        type: 'item',
        path: '/sessions/logout',
      },
    ];
    this.setLayout({ menuFooter: this.menuFooter });
  }

  setMenu() {
    this.menu = [
      {
        icon: 'search_insights',
        label: 'Selecionar Organização',
        shortLabel: 'Selecionar Organização',
        type: 'item',
        path: '/organizacoes',
        actions: ['CHECK_ONLY_ONE_ORGANIZATION', 'ACTIVE']
      },
      ...this.menuHeathOperator,
      ...this.menuBroker,
      ...this.menuHumanResources,
      ...this.menuGroup,
      ...this.menuSalesPerson,
    ];
    this.setLayout({ menu: this.menu });
  }

  get menuSalesPerson(): Menu[] {
    return [
      {
        icon: 'payments',
        label: 'Bônus',
        shortLabel: 'Bônus',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/vendedor/bonus',
        acl: ['SALESPERSON'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
      {
        icon: 'tornado_outlined',
        label: 'Adesão',
        shortLabel: 'Adesão',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/vendedor/adesao-prevencao',
        acl: ['SALESPERSON'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
    ];
  }

  get menuGroup(): Menu[] {
    return [
      {
        icon: 'medical_services',
        label: 'Atendimento',
        shortLabel: 'Atendimento',
        type: 'item',
        showPath: false,
        acl: ['GROUP'],
        path: '/organizacoes/organizationId/atendimento',
        actions: ['ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_DOCTOR']
      },
      {
        icon: 'group_search',
        label: 'Consultar paciente',
        shortLabel: 'Consultar paciente',
        type: 'item',
        showPath: false,
        acl: ['GROUP'],
        path: '/organizacoes/organizationId/consultar-paciente',
        actions: ['ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'FF_PAINEL_CONSULTAR_PACIENTE', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER']
      },
      {
        icon: 'tornado_outlined',
        label: 'Adesão',
        shortLabel: 'Adesão',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/adesao',
        acl: ['GROUP'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'FF_PAINEL_PERSON_EXPORTS_SUBSCRIPTION', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER',
        ]
      },
      {
        // SAUDE
        icon: this.reportsService.getReportIcon('saude-grupo'),
        label: this.reportsService.getReportTitle('saude-grupo'),
        shortLabel: this.reportsService.getReportShortLabel('saude-grupo'),
        path: this.reportsService.getReportUrl('saude-grupo'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('saude-grupo'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'MIN_SUBSCRIPTION_30', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
      {
        icon: 'summarize',
        label: 'Relatório Saúde mental',
        shortLabel: 'Saúde mental',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/nr1',
        acl: ['GROUP'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'FF_PAINEL_PSYCHOSOCIAL_REPORT', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER',
        ]
      },
      {
        // DADOS CADASTRAIS
        icon: this.reportsService.getReportIcon('dados-gerais-grupo'),
        label: this.reportsService.getReportTitle('dados-gerais-grupo'),
        shortLabel: this.reportsService.getReportShortLabel('dados-gerais-grupo'),
        path: this.reportsService.getReportUrl('dados-gerais-grupo'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('dados-gerais-grupo'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'MIN_SUBSCRIPTION_30', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
      {
        icon: 'flash_on',
        label: 'Incentivo',
        shortLabel: 'Incentivo',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/incentivo',
        acl: ['GROUP'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'MIN_SUBSCRIPTIONS_30_OR_NO_CYCLE_INCENTIVE', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER',
        ]
      },
      {
        // FINANCEIRO
        icon: this.reportsService.getReportIcon('relatorio-financeiro-grupo'),
        label: this.reportsService.getReportTitle('relatorio-financeiro-grupo'),
        shortLabel: this.reportsService.getReportShortLabel('relatorio-financeiro-grupo'),
        path: this.reportsService.getReportUrl('relatorio-financeiro-grupo'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('relatorio-financeiro-grupo'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'MIN_SUBSCRIPTION_30', 'FF_PAINEL_ORGANIZATION_REPORTS_61', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ],
      },
    ];
  }

  get menuHumanResources(): Menu[] {
    return [
      {
        icon: 'medical_services',
        label: 'Atendimento',
        shortLabel: 'Atendimento',
        type: 'item',
        showPath: false,
        acl: ['HUMAN_RESOURCES'],
        path: '/organizacoes/organizationId/atendimento',
        actions: ['ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_DOCTOR']
      },
      {
        icon: 'group_search',
        label: 'Consultar paciente',
        shortLabel: 'Consultar paciente',
        type: 'item',
        showPath: false,
        acl: ['HUMAN_RESOURCES'],
        path: '/organizacoes/organizationId/consultar-paciente',
        actions: ['ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'FF_PAINEL_CONSULTAR_PACIENTE', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER']
      },
      {
        icon: 'tornado_outlined',
        label: 'Adesão',
        shortLabel: 'Adesão',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/adesao',
        acl: ['HUMAN_RESOURCES'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'FF_PAINEL_PERSON_EXPORTS_SUBSCRIPTION', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER',
        ]
      },
      {
        // SAUDE
        icon: this.reportsService.getReportIcon('saude'),
        label: this.reportsService.getReportTitle('saude'),
        shortLabel: this.reportsService.getReportShortLabel('saude'),
        path: this.reportsService.getReportUrl('saude'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('saude'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'MIN_SUBSCRIPTION_30', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
      {
        icon: 'summarize',
        label: 'Relatório Saúde mental',
        shortLabel: 'Saúde mental',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/nr1',
        acl: ['HUMAN_RESOURCES'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'FF_PAINEL_PSYCHOSOCIAL_REPORT', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER',
        ]
      },
      {
        // DADOS CADASTRAIS
        icon: this.reportsService.getReportIcon('dados-gerais'),
        label: this.reportsService.getReportTitle('dados-gerais'),
        shortLabel: this.reportsService.getReportShortLabel('dados-gerais'),
        path: this.reportsService.getReportUrl('dados-gerais'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('dados-gerais'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'MIN_SUBSCRIPTION_30', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
      {
        icon: 'flash_on',
        label: 'Incentivo',
        shortLabel: 'Incentivo',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/incentivo',
        acl: ['HUMAN_RESOURCES'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'CHECK_CYCLE_INCENTIVE', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER',
        ]
      },
      {
        // FINANCEIRO
        icon: this.reportsService.getReportIcon('relatorio-financeiro'),
        label: this.reportsService.getReportTitle('relatorio-financeiro'),
        shortLabel: this.reportsService.getReportShortLabel('relatorio-financeiro'),
        path: this.reportsService.getReportUrl('relatorio-financeiro'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('relatorio-financeiro'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'MIN_SUBSCRIPTION_30', 'FF_PAINEL_ORGANIZATION_REPORTS_61', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ],
      },

    ];
  }

  get menuBroker(): Menu[] {
    return [
      {
        icon: 'medical_services',
        label: 'Atendimento',
        shortLabel: 'Atendimento',
        type: 'item',
        showPath: false,
        acl: ['BROKER'],
        path: '/organizacoes/organizationId/atendimento',
        actions: ['ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_DOCTOR']
      },
      {
        icon: 'group_search',
        label: 'Consultar paciente',
        shortLabel: 'Consultar paciente',
        type: 'item',
        showPath: false,
        acl: ['BROKER'],
        path: '/organizacoes/organizationId/consultar-paciente',
        actions: ['ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'FF_PAINEL_CONSULTAR_PACIENTE', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER']
      },
      {
        icon: 'person_search',
        label: 'Cliente',
        shortLabel: 'Cliente',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/rhs',
        acl: ['BROKER'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER',
        ]
      },
      {
        // Perfil populacional
        icon: this.reportsService.getReportIcon('dados-cadastrais-corretor'),
        label: this.reportsService.getReportTitle('dados-cadastrais-corretor'),
        shortLabel: this.reportsService.getReportShortLabel('dados-cadastrais-corretor'),
        path: this.reportsService.getReportUrl('dados-cadastrais-corretor'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('dados-cadastrais-corretor'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
      {
        // Adesão HO
        icon: this.reportsService.getReportIcon('custos-prevencao-corretor'),
        label: this.reportsService.getReportTitle('custos-prevencao-corretor'),
        shortLabel: this.reportsService.getReportShortLabel('custos-prevencao-corretor'),
        path: this.reportsService.getReportUrl('custos-prevencao-corretor'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('custos-prevencao-corretor'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
      {
        // Saúde
        icon: this.reportsService.getReportIcon('saude-operadora-corretor'),
        label: this.reportsService.getReportShortLabel('saude-operadora-corretor'),
        shortLabel: this.reportsService.getReportTitle('saude-operadora-corretor'),
        path: this.reportsService.getReportUrl('saude-operadora-corretor'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('saude-operadora-corretor'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
    ];
  }

  get menuHeathOperator(): Menu[] {
    return [
      {
        icon: 'medical_services',
        label: 'Atendimento',
        shortLabel: 'Atendimento',
        type: 'item',
        showPath: false,
        acl: ['HEALTH_OPERATOR'],
        path: '/organizacoes/organizationId/atendimento',
        actions: ['ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_DOCTOR']
      },
      {
        icon: 'group_search',
        label: 'Consultar paciente',
        shortLabel: 'Consultar paciente',
        type: 'item',
        showPath: false,
        acl: ['HEALTH_OPERATOR'],
        path: '/organizacoes/organizationId/consultar-paciente',
        actions: ['ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'FF_PAINEL_CONSULTAR_PACIENTE', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER']
      },
      {
        icon: 'person_search',
        label: 'Cliente',
        shortLabel: 'Cliente',
        type: 'item',
        showPath: false,
        path: '/organizacoes/organizationId/rhs',
        acl: ['HEALTH_OPERATOR'],
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER',
        ]
      },
      {
        // Perfil populacional
        icon: this.reportsService.getReportIcon('dados-cadastrais'),
        label: this.reportsService.getReportTitle('dados-cadastrais'),
        shortLabel: this.reportsService.getReportShortLabel('dados-cadastrais'),
        path: this.reportsService.getReportUrl('dados-cadastrais'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('dados-cadastrais'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
      {
        // Adesão HO
        icon: this.reportsService.getReportIcon('adesao-operadora'),
        label: this.reportsService.getReportTitle('adesao-operadora'),
        shortLabel: this.reportsService.getReportShortLabel('adesao-operadora'),
        path: this.reportsService.getReportUrl('adesao-operadora'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('adesao-operadora'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
      {
        // Custos da prevenção
        icon: this.reportsService.getReportIcon('custos-prevencao'),
        label: this.reportsService.getReportTitle('custos-prevencao'),
        shortLabel: this.reportsService.getReportShortLabel('custos-prevencao'),
        path: this.reportsService.getReportUrl('custos-prevencao'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('custos-prevencao'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
      {
        // Saúde
        icon: this.reportsService.getReportIcon('saude-operadora'),
        label: this.reportsService.getReportShortLabel('saude-operadora'),
        shortLabel: this.reportsService.getReportTitle('saude-operadora'),
        path: this.reportsService.getReportUrl('saude-operadora'),
        type: 'item',
        showPath: false,
        acl: this.reportsService.getReportAcl('saude-operadora'),
        actions: [
          'ORGANIZATION_TYPE', 'ORGANIZATION_ID_REQUIRED', 'ACTIVE', 'ORGANIZATION_ID_REPLACE', 'USER_TYPE_MANAGER'
        ]
      },
    ];
  }

  setTitle(titlePage: string) {
    this.layoutConf = { ...this.layoutConf, titlePage };
  }
}

export interface Menu {
  path?: string;
  showPath?: boolean;
  acl?: OrganizationType[],
  actions?: MenuActions[];
  featureFlags?: FeatureFlagSearchNames[];
  icon?: string;
  label?: string;
  shortLabel?: string;
  active?: boolean;
  type: 'item' | 'submenu' | 'divider';
  extras?: {
    minSubscriptions?: number
  }
  /*
  * Do not set this property
  * */
  toRemove?: boolean;
}

export type MenuActions =
  'MIN_SUBSCRIPTION_30'
  | 'ACTIVE'
  | 'FF_PAINEL_ORGANIZATION_REPORTS_61'
  | 'FF_PAINEL_PERSON_EXPORTS_SUBSCRIPTION'
  | 'FF_PAINEL_PSYCHOSOCIAL_REPORT'
  | 'FF_PAINEL_CONSULTAR_PACIENTE'
  | 'ORGANIZATION_ID_REQUIRED'
  | 'ORGANIZATION_ID_REPLACE'
  | 'CHECK_CYCLE_INCENTIVE'
  | 'MIN_SUBSCRIPTIONS_30_OR_NO_CYCLE_INCENTIVE'
  | 'CHECK_ONLY_ONE_ORGANIZATION'
  | 'USER_TYPE_MANAGER'
  | 'USER_TYPE_DOCTOR'
  | 'ORGANIZATION_TYPE';
